import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, getToken } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    if (!getToken()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_2fa) {
      return { requires2fa: true, challengeToken: data.challenge_token };
    }
    setToken(data.access_token);
    setUser(data.user);
    return { user: data.user };
  };

  const verify2fa = async (challengeToken, code) => {
    const { data } = await api.post("/auth/login/2fa", {
      challenge_token: challengeToken,
      code,
    });
    setToken(data.access_token);
    setUser(data.user);
    return {
      user: data.user,
      backupCodeUsed: data.backup_code_used,
      backupCodesLeft: data.backup_codes_left,
    };
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, verify2fa, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
